module.exports = __webpack_public_path__ + "static/tax-list-0fbee763288afd0385d939f33c3c4e22.png";